(() => {
  const header = document.querySelector('.rfb-header');
  if (!header) return;
  const toggle = header.querySelector('.rfb-menu-toggle');
  const groups = [...header.querySelectorAll('.rfb-group')];
  let originalOverflow = '';
  const setMenu = open => {
    const wasOpen = header.dataset.menuOpen === 'true';
    header.dataset.menuOpen = String(open);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? toggle.dataset.closeLabel : toggle.dataset.openLabel);
    if (open && !wasOpen) {
      originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    } else if (!open && wasOpen) {
      document.body.style.overflow = originalOverflow;
      groups.forEach(group => group.open = false);
    }
  };
  toggle.addEventListener('click', () => setMenu(toggle.getAttribute('aria-expanded') !== 'true'));
  groups.forEach(group => group.addEventListener('toggle', () => {
    if (group.open) groups.forEach(other => { if (other !== group) other.open = false; });
  }));
  document.addEventListener('click', event => {
    if (!header.contains(event.target)) {
      groups.forEach(group => group.open = false);
      if (header.dataset.menuOpen === 'true') setMenu(false);
    }
  });
  header.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const openGroup = groups.find(group => group.open);
    if (openGroup) {
      openGroup.open = false;
      openGroup.querySelector('summary').focus();
    } else if (header.dataset.menuOpen === 'true') {
      setMenu(false);
      toggle.focus();
    }
  });
  header.querySelectorAll('nav a').forEach(link => link.addEventListener('click', () => setMenu(false)));
  window.addEventListener('resize', () => { if (innerWidth >= 799 && header.dataset.menuOpen === 'true') setMenu(false); }, {passive:true});
})();
